

















import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { DirectDebitFile } from '@accounting/interfaces/direct-debit-file';

@Component({
  name: 'bpc-export-direct-debit-file-modal',
  components: {},
})
export default class ExportDirectDebitFileModal extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: 'export-direct-debit-file' })
  readonly modalId: string;
  @Prop({ type: Object, default: null }) readonly entity: DirectDebitFile;

  // DATA
  public loading = false;
  public isProcessing: boolean = false;

  // LIFECYCLE
  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get modalTitle(): string {
    if (this.entity && this.entity.status === 'draft') {
      return this.$t('direct-debit-file.modal.confirmAndExport.title') as string;
    }
    return this.$t('direct-debit-file.modal.export.title') as string;
  }

  get modalbody(): string {
    if (this.entity && this.entity.status === 'draft') {
      return this.$t('direct-debit-file.modal.confirmAndExport.body') as string;
    }
    return this.$t('direct-debit-file.modal.export.body') as string;
  }

  // METHODS
  closeModal() {
    this.$emit('close-modal');
  }

  exportedDirectDebitFile() {
    this.$emit('exported-direct-debit-file');
  }

  onConfirmExportDirectDebitFile() {
    const path = `${this.$bpcApiRouteHelper.getEntityPath('direct-debit-files')}/${
      this.entity.id
    }/export`;
    const sessionCode = this.getSessionCode();
    this.listenToWebsocketExportedDirectDebitFileChannel(sessionCode);

    this.isProcessing = true;

    const payload: AnyEntity = {
      session_code: sessionCode,
    };

    this.$bpcApi.post(path, payload).subscribe();
  }

  listenToWebsocketExportedDirectDebitFileChannel(sessionCode) {
    this.isProcessing = true;
    this.$bpcEcho
      .getExportDirectDebitFileChannel(sessionCode)
      .listen('.BPC\\Accounting\\Events\\ExportDirectDebitFileCompleted', async data => {
        //this.eventsSuccess.push(data);
        this.$bpcEcho.leaveExportDirectDebitFileChannel(sessionCode);
        this.downloadFile();
        this.exportedDirectDebitFile();
        this.isProcessing = false;
      })
      .listen('.BPC\\Accounting\\Events\\GlobalErrorExportDirectDebitFile', data => {
        this.$bpcMessage.showErrorMessage({
          text: data.msg,
        });
        this.isProcessing = false;
        this.$bpcEcho.leaveExportDirectDebitFileChannel(sessionCode);
      });
  }

  downloadFile() {
    const path = `${this.$bpcApiRouteHelper.getEntityPath('direct-debit-files')}/${
      this.entity.id
    }/download`;

    this.$bpcApi.download(path, 'download.xml', {});
  }

  manageExportDirectDebitFile(error) {
    this.loading = false;

    const exceptionType = error?.response?.data?.exception;
    const message = error?.response?.data?.message;
    /*switch (exceptionType) {
      case 'BPC\\AccountingIntegrations\\Exceptions\\TenantNotReadyToSyncInvoicesException':
        this.$bpcMessage.showErrorMessage({ text: message });
        this.showInvoiceSyncSettingForm = true;
        break;

      default:
        this.$bpcMessage.showErrorMessage({
          text: 'global.invoices_to_sync_item.error',
        });
        break;
    }
    */
  }

  resetModal() {
    this.loading = false;
    this.isProcessing = false;
  }

  getSessionCode() {
    return `export-direct-debit-file-${this.tenantId}-${this.generateUUIDv4()}`;
  }

  generateUUIDv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  openModal() {
    this.$bvModal.show(this.modalId);
  }

  // WATCHERS
  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.resetModal();
      this.openModal();
    } else {
      this.$bvModal.hide(this.modalId);
    }
  }
}
